// neúspěch nesmí projít jako prázdný výpis ani validní hodnota — volající na reject ukáže chybový stav
export const requireSuccessfulResult = (response: any, errorMessage: string): any => {
	const result = response?.result;
	if (!result?.success) {
		throw new Error(errorMessage);
	}

	return result;
};
